module.exports = __webpack_public_path__ + "static/media/hb-online-logo.45548856.png";